import React from 'react';

import FullSchemaViewer from '../../components/Rbac/SchemaViewer/FullSchemaViewer';

function SchemaView() {
  return <FullSchemaViewer />;
}

export default SchemaView;
